var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.loadSkeleton || _vm.showEmptyTemplate)?[_vm._t("default",null,{"isLoading":_vm.hideTemplatebeforeReq})]:_vm._e(),_vm._v(" "),(_vm.loadSkeleton)?[_c(_vm.id,{tag:"component",attrs:{"count":_vm.count}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }